/** Which document the school issued for a Payment (mirrors PortalPaymentDocumentKindContract). */
export enum PortalPaymentDocumentKind {
  Invoice = "Invoice",
  Receipt = "Receipt",
}
